
require('./speech-recognition-fact.component.scss');

class SpeechRecognitionFactController {
  constructor(
    $scope,
    $element,
    $cookies,
    $http,
    $httpParamSerializer,
    $timeout,
    $interval,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$cookies = $cookies;
    this.$http = $http;
    this.$httpParamSerializer = $httpParamSerializer;
  }

  get isBottom() {
    return this.$element.attr('bottom') !== undefined;
  }

  get isSelected() {
    return this.fact.selected;
  }

  get isProcessing() {
    return !!this.recognize_promise;
  }

  get isError() {
    return (!!this.result && !!this.result.error);
  }

  get hasTranscript() {
    return (!!this.result && this.result.transcript !== undefined);
  }

  recognize() {
    if (!this.isProcessing) {
      let params = {
          event_id: this.fact.id,
          force: true,
      }

      this.recognize_promise = this.$http.post(
        '/speech_processing/recognize',
        this.$httpParamSerializer(params),
        {headers: {
          'Accept': 'application/json;charset=utf-8',
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'application/x-www-form-urlencoded',
        }});

      this.recognize_promise
        .then((response) => {
          delete this.recognize_promise;
          this.result = response.data;
          this.fact.text_data = this.result.transcript;
        })
        .catch((error) => {
          delete this.recognize_promise;
          this.result = {
            error: 'unhandled',
            message: gettext((error.data && angular.isString(error.data.message))
                             ? error.data.message
                             : 'Неизвестная ошибка'),
          }
        });

    }
  }
}

export const SpeechRecognitionFactComponent = {
  restrict: 'E',
  template: require('./speech-recognition-fact.component.html'),
  controller: SpeechRecognitionFactController,
  controllerAs: '$ctrl',
  bindings: {fact: '='},
}



// WEBPACK FOOTER //
// ./src/facts/speech-recognition/speech-recognition-fact.component.js